// extracted by mini-css-extract-plugin
export default {"section":"Winter_section__oHT6b","container":"Winter_container__fcQjF","container__photo":"Winter_container__photo__durv4","photo":"Winter_photo__jaGQ+"};